<template>
  <v-row id="import-position-field-form">
    <v-col cols="12" md="12" class="my-0 py-0">
      <v-select
        v-model="myPosition.type"
        :items="positionTypes"
        :label="$t('views.stocks.stockModal.type.label')"
        :disabled="loading || disabled"
        hide-details
      ></v-select>
    </v-col>

    <template v-if="myPosition && myPosition.type">
      <template
        v-if="
          ['stock', 'fund', 'right', 'etf', 'plan', 'bond', 'putOption', 'callOption'].indexOf(
            myPosition.type
          ) > -1
        "
      >
        <v-col cols="12" md="3">
          <div class="items-flex">
            <v-text-field
              v-model="myPosition.ticker"
              :label="tickerLabelTranslation"
              :disabled="loading || disabled"
              maxLength="30"
              hide-details
            />
            <span class="ml-2">
              <InfoIcon :size="15" :text="tickerLabelHelp" />
            </span>
          </div>
        </v-col>
        <v-col v-if="showCountrySelector" cols="12" md="3">
          <div class="items-flex">
            <CountrySelector
              v-model="myPosition.country"
              :countries="countrySelectorList"
              :label="$t('views.stocks.stockModal.country')"
              translate-name
              :disabled="loading || disabled"
              hide-details
            />
            <span class="ml-2">
              <InfoIcon
                :size="15"
                :text="$t(`views.stocks.stockModal.countryHelp.${myPosition.type}`)"
              />
            </span>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <CurrencySelector
            v-model="myPosition.currency"
            :disabled="loading || disabled"
            model="position"
            :label="$t('views.stocks.stockModal.currency')"
            :currencyFilter="positionCurrenciesFilter"
          />
        </v-col>
      </template>
      <template v-if="myPosition.type === 'crypto'">
        <v-col cols="12" md="3">
          <div class="items-flex">
            <v-text-field
              v-model="myPosition.ticker"
              :label="tickerLabelTranslation"
              :disabled="loading || disabled"
              maxLength="30"
              hide-details
            />
            <span class="ml-2">
              <InfoIcon :size="15" :text="tickerLabelHelp" />
            </span>
          </div>
        </v-col>
      </template>
      <template v-if="myPosition.type === 'commodity'">
        <v-col cols="12" md="3">
          <v-autocomplete
            v-model="myPosition.ticker"
            :items="commodityPositionTickers"
            :disabled="loading || disabled"
            :label="$t('views.stocks.stockModal.commodityPosition.commodityPosition')"
            :placeholder="$t('views.stocks.stockModal.commodityPosition.commodityPosition')"
            hide-no-data
            hide-details
          ></v-autocomplete>
        </v-col>
      </template>
      <template v-if="myPosition.type === 'cash'">
        <v-col cols="12" md="3">
          <v-autocomplete
            v-model="myPosition.ticker"
            :items="cashPositionTickers"
            :disabled="loading || disabled"
            :label="$t('views.stocks.stockModal.cashPosition.currency')"
            :placeholder="$t('views.stocks.stockModal.cashPosition.currency')"
            hide-no-data
            hide-details
          ></v-autocomplete>
        </v-col>
      </template>

      <v-col
        v-if="showExchangeSelector && exchangeSelectorList && exchangeSelectorList.length"
        cols="12"
        md="3"
      >
        <div class="items-flex">
          <v-select
            v-model="myPosition.exchange"
            :items="exchangeSelectorList"
            :label="$t('views.stocks.stockModal.exchange.label')"
            :disabled="loading || disabled"
            hide-details
          ></v-select>
          <span class="ml-2">
            <InfoIcon :size="15" :text="$t('views.stocks.stockModal.exchange.help')" />
          </span>
        </div>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import PositionFormMixin from '@/views/components/common/positions/PositionFormMixin'

export default {
  mixins: [PositionFormMixin],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isImportPositionFormInDict: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    type: 'position',
    isImportPositionForm: true,
  }),
}
</script>

<style lang="scss">
#import-position-field-form {
  h1 {
    font-size: 17px;
    font-weight: 400;
  }
  .items-flex {
    display: flex;
    align-items: flex-end;
  }
}
</style>
